import { utmKeyMapping } from '@otovo/shared/lib/analytics/utmConfig';
import getFirstFromArray from '@otovo/shared/utils/getFirstFromArray';

export function extractUtmFromQuery(query: Record<string, string | string[]>) {
  const utmData: Record<string, string | undefined> = {};

  // Use the mapping to support both full and shorthand UTM codes
  Object.entries(utmKeyMapping).forEach(([utmKey, possibleKeys]) => {
    for (const key of possibleKeys) {
      const value = getFirstFromArray(query[key]);
      if (value) {
        utmData[utmKey] = value;
        break; // Use first match, don't override
      }
    }
  });

  return utmData;
}
